import {AfterViewChecked, Component, ElementRef, HostBinding, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'content-diagram',
  templateUrl: 'content-diagram.html',
  styleUrls: ['content-diagram.scss'],
})
export class ContentDiagramComponent implements AfterViewChecked {

  @HostBinding("style.--offset1")
  public offset1: number = 0;

  @HostBinding("style.--font-rel-size")
  public fontRelSize: string = '24px';

  @ViewChild('holder') private holder: ElementRef;

  public animate: string = 'animate';

  public _value: number;
  public _total: number;
  
  private fontCheckDone = false;

  constructor(
  ) { }

  @Input() public set value(value: number) {
    if (this._total !== undefined) {
      if ( this._value > this._total ) {
        this._total = value;
      }
      this.offset1 = 258 - 258 * this.toFaktor(value/this._total);
    }
    this._value = value;
  }

  @Input() public set total(total: number) {
    const t = this._value !== undefined && this._value > total ? this._value : total;
    if (this._value !== undefined) {
      this.offset1 = 258 - 258 * this.toFaktor(this._value/t);
    }
    this._total = t;
  }

  // value < 0 hides; 0 makes a dot
  private toFaktor(value): number {
    if ( value < 0 ) {
      return 0;
    }
    if ( value < 0.001 ) {
      return 0.001
    }
    return value; 
  };

  public doAanimate() {
    this.animate = '';
    setTimeout(() => this.animate = 'animate');
  }

  ngAfterViewChecked() {
    if ( !this.fontCheckDone ) {
      this.fontCheckDone = true;
      const holder: HTMLSpanElement = this.holder.nativeElement;
      let h = holder.offsetHeight;
      const div = (this._total !== undefined && this._total > 9 ) ? 4 : 3;
      setTimeout(() => { this.fontRelSize = (h/div) + 'px'; });
    }
  }
}
